import React from 'react';
// import EditorNoSSR from './EditorNoSSR';
import Embed from '@editorjs/embed'
import Table from '@editorjs/table'
import Paragraph from '@editorjs/paragraph'
import List from '@editorjs/list'
import Warning from '@editorjs/warning'
import Code from '@editorjs/code'
import LinkTool from '@editorjs/link'
import Image from '@editorjs/image'
import Raw from '@editorjs/raw'
import Header from '@editorjs/header'
import Quote from '@editorjs/quote'
import Marker from '@editorjs/marker'
import CheckList from '@editorjs/checklist'
import Delimiter from '@editorjs/delimiter'
import InlineCode from '@editorjs/inline-code'
import SimpleImage from '@editorjs/simple-image'
import { createReactEditorJS } from 'react-editor-js'
import { Box, Button, Paper } from '@mui/material';

import MyImage from './plugin/MyImage';
import AppBar from './plugin/AppBar';
import "./plugin/AppBar.css";
import AppBarDialog from './plugin/AppBarDialog';
import VerticalMenu from './plugin/VerticalMenu';

const ReactEditorJS = createReactEditorJS()


export default function VeryEditorJS(props) {
    const {blocks, setBlocks, action} = props;
    const [open, setOpen] = React.useState(false);
    const [openVM, setOpenVM] = React.useState(false);
    const [data, setData] = React.useState();
    
    const EDITOR_JS_TOOLS = {
        // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
        // paragraph: Paragraph,
        embed: Embed,
        table: Table,
        list: List,
        warning: Warning,
        code: Code,
        linkTool: LinkTool,
        image: Image,
        raw: Raw,
        header: Header,
        quote: Quote,
        marker: Marker,
        checklist: CheckList,
        delimiter: Delimiter,
        inlineCode: InlineCode,
        // simpleImage: SimpleImage,
        // myImage: {
        //     class: MyImage,
        //     inlineToolbar: true,
        //     config: {
        //         placeholder: 'Paste image URL'
        //     }
        // },
        appBar: {
            class: AppBar,
            inlineToolbar: false,
            config: {
                placeholder: 'Informa um AppBar',
                setOpen: setOpen,
                setData: setData
            }
        },
        verticalMenu: {
            class: VerticalMenu,
            config: {
                setOpen: setOpenVM,
                //setData: setData
            }
        }
    }
    const editorCore = React.useRef(null);

    const handleInitialize = React.useCallback((instance) => {
        console.log('>>>handleInitialize<<<')
        editorCore.current = instance
    }, [])

    const handleSave = React.useCallback(async () => {
        const savedData = await editorCore.current.save();
        console.log(savedData);
        if( setBlocks) setBlocks( savedData);
    }, [])
    function onAction(dado) {
        console.log(dado);
        if( action)action( dado );

        // let d = {...blocks};
        // if( d.blocks.length === 0 ){
        //     d.blocks.push( dado )
        // }else{
        //     for( let x in d.blocks ){
        //         let item = d.blocks[x];
        //         if( item.id === dado.id){
        //             item = dado;
        //             break;
        //         }
        //     }
        // }
        // setBlocks( d );
        // console.log( d );

        // const b = ReactEditorJS;//.getBlockByIndex(0);
        // console.log( b );
    }

    const handleEditorChange = async (api, event) => {
        const data = await api.saver.save();
        
        if( setBlocks) setBlocks(data);
    };

    return (
        <Box
                component="section"
                sx={{
                    p: 2, border: '1px groove grey',
                    ml: '5%'
                }}
            >
            <Box
                component="section"
                sx={{
                    p: 2,
                    ml: '5%'
                }}
            >
                <ReactEditorJS
                    onInitialize={handleInitialize}
                    // defaultValue={blocks} 
                    // value={blocks}
                    data={blocks}
                    tools={EDITOR_JS_TOOLS}
                    onReady={() => console.log('Editor.js is ready to work!')}
                    onChange={handleEditorChange}
                >

                </ReactEditorJS>
            </Box>
            {data && data.tipo === 'AppBar' &&
                <AppBarDialog open={open} setOpen={setOpen} data={data} action={onAction} />
            }
        </Box>
    )
}